/* You can add your custom scripts here */

/* Cookie consent preferences — open Shopify's native banner from the footer link */
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cookie-preferences]');
    if (!trigger) return;
    var banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') {
      event.preventDefault();
      banner.showPreferences();
    }
    // else: fall through, anchor navigates to privacy policy
  });
})();

/* === Header inline-expanding search === */
class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.header-search__input');
    this.submit = this.querySelector('.header-search__submit');
    this.clear = this.querySelector('.header-search__clear');
    this.form = this.querySelector('form');
    this.headerRoot = this.closest('.section-header');

    this.submit.addEventListener('click', this.onSubmitClick.bind(this));
    this.clear.addEventListener('click', this.onClearClick.bind(this));
    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('keydown', this.onKeydown.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));

    if (this.hasValue) this.classList.add('has-value');
  }

  get isOpen()   { return this.classList.contains('is-open'); }
  get hasValue() { return this.input.value.trim().length > 0; }

  open() {
    this.classList.add('is-open');
    this.headerRoot?.classList.add('header-search-open');
    this.submit.setAttribute('aria-expanded', 'true');
    this.input.removeAttribute('tabindex');
    this.clear.removeAttribute('tabindex');
    this.input.focus();
  }

  close() {
    this.classList.remove('is-open');
    this.headerRoot?.classList.remove('header-search-open');
    this.submit.setAttribute('aria-expanded', 'false');
    this.input.setAttribute('tabindex', '-1');
    this.clear.setAttribute('tabindex', '-1');
  }

  clearAndClose() {
    this.input.value = '';
    this.classList.remove('has-value');
    this.close();
    this.submit.focus();
  }

  onSubmitClick(e) {
    if (!this.isOpen) {
      e.preventDefault();
      this.open();
      return;
    }
    if (!this.hasValue) {
      e.preventDefault();
      return;
    }
    // open + has value → let the form submit naturally
  }

  onClearClick(e) {
    e.preventDefault();
    this.clearAndClose();
  }

  onInput() {
    this.classList.toggle('has-value', this.hasValue);
  }

  onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.clearAndClose();
    }
  }

  onDocumentClick(e) {
    if (!this.isOpen) return;
    if (this.contains(e.target)) return;
    if (!this.hasValue) this.close();
  }
}

customElements.define('header-search', HeaderSearch);
